<template lang="pug">
  include ../mixins
  +b.ma.--top_2xs
    row.position--relative(space="2sm-xl")
      ui-preloader(v-if="isLoad" loader-color='loader-wrapper__bg--light')
      cell(cols="12 3-xl 2-xxl")
        +b.u-display--hidden.--block-xl.ma--bottom_sm
          +b.de-card--color_white.--space_sm
            slot(name="categories")
        +b.de-card--color_white.--space_sm.--variant_fullheight.ma--bottom_3sm.filter-wrapper.position--relative(
          :class="{'is-active': isShowFilters == true}"
        )
          +b.u-display--hidden-xl
            ui-preloader(v-if="isLoad" loader-color='loader-wrapper__bg--white')
          +b.filter-close.u-display--hidden-xl.BUTTON(@click="toggleFilter")
            bem-icon.z-index--2(
              type="close"
              size="3sm"
              color="main"
              variant="right"
              @click="toggleFilter"
            )
          +b.ma--bottom_2md.u-display--block.--hidden-xl
            slot(name="categories")
          filter-section(
            v-if="filters.length > 0"
            :filters="filters"
            :params-obj="paramsObj"
            @update-params="paramsObj = $event; getCardsAndSeries()"
            :is-selected-block="isSelectedArray"
            @clear-filters="clearFilters"
            @update-selected="selectedArray = $event; isAddPage = false"
            :selected-array="selectedArray"
            :landing="landing"
          )
          +b.filter-wrapper__button.de-card--color_white.--space_2xs.u-display--hidden-xl.filter-apply(:class="{'is-active': isShowFilters == true}")
            row(justify="center")
              cell(cols="12 8-sm 4-md")
                +b.de-card--space_xs
                  bem-button(
                    appearance="border-accent-1"
                    width="full"
                    space="sm"
                    rounded="lg"
                    @event="toggleFilter()"
                  ) {{_('Застосувати')}}
      cell(cols="12 9-xl 10-xxl")
        +b.filter-btn.ma--center.u-display--hidden-xl.ma--bottom_sm.ma--top_sm.BUTTON(
          @click="toggleFilter"
          ref="filterButton"
        ) {{_('Фильтры')}}
        +b.H1.de-text--color_main.--height_sm.--size_2md.--weight_light.ma--bottom_sm(
          v-if="catalogTitle"
        ) {{ catalogTitle }}
        slot(
          v-else
          name="title"
        )
        +b.de-card--color_white.--space_3xs.ma--bottom_2md
          row(align="center")
            cell(cols="auto")
              filter-selected(
                :amount="amount"
                @clear-filters="clearFilters"
                :selected-array="selectedArray"
                @delete-selected="isAddPage = false; deleteSelectedFilter($event)"
              )
            cell(cols="12 narrow-xl")
              +b.common-multiselect
                multiselect(
                  :options="sortArray"
                  v-model="sortValue"
                  track-by="value"
                  label="title"
                  name="sort"
                  :allow-empty="false"
                  @input="isAddPage = false; getCards()"
                )
        +b.ma--bottom_2sm(ref="cards")
          bem-text(
            tag="p"
            weight="light"
            size="md"
          ) {{_('Товары')}}
        div(:style="{ minHeight: initialHeight+'px' }")
          template(v-if="!isCardsResponse")
            slot(name="products")
          template(v-if="isCardsResponse === true")
            row.ma--bottom_sm(space="sm-xl" v-if="cardsResponse.length")
              +b.custom-width.ma--bottom_2xs.--bottom_sm-xl.CELL(
                v-for="(product, index) in cardsResponse"
                :key="index"
              )
                product-card(
                  :key="product.id"
                  :product-data="product"
                  :object-item="objectItem"
                )
            bem-text(
              v-else
              tag="p"
              weight="light"
              size="sm"
            ) {{_('Список товаров пуст')}}
        template(v-if="!isSeriesResponse")
          div(@click="seriesListener($event)")
            slot(name="series")
        div(@click="seriesListener($event)")
          renderer(
            v-if="isSeriesResponse"
            :result="seriesResponse"
          )
        template(v-if="!isLevelsResponse")
          slot(name="levels")
        renderer(
          v-else
          :result="levelsResponse"
        )
        pagination.ma--top_md(
          v-if="count > perPage"
          class-wrapper="pagination__wrapper--light"
          :current='page'
          :total='count'
          :perPage='perPage'
          :is-add-more="true"
          @add="isAddPage = $event"
          @page-changed="page = $event; getCards($event); scrollByPagination()"
        )
</template>

<script>
import CatalogMixin from '@mixins/catalog.mixin.js'
import { valueFromSelect } from '@helpers/utils'
import { scrollToContent } from '@helpers/scroll'
import {
  catalogFiltersResource,
  catalogSeriesResource,
  catalogCardsResource,
} from '@services/catalog.service.js'
import { getCookie, setCookie } from '@resource/cookie'

const one = 1

export default {
  name: 'product-catalog',
  mixins: [CatalogMixin],
  components: {
    'filter-section': () => import('./FilterSection'),
    'filter-selected': () => import('./FilterSelected'),
    'product-card': () => import('@app/Cards/ProductCard'),
    'ui-preloader': () => import('@app/UiElements/UiPreloader'),
    pagination: () => import('@app/UiElements/Pagination'),
  },
  props: {
    category: String,
    slug: String,
    pagination: Object,
    productsAmount: Number,
    objectItem: Object,
  },
  data() {
    return {
      paramsObj: {},
      sortValue: null,
      sortArray: [
        { title: this._('Популярные'), value: 'popular' },
        { title: this._('По увеличению цены'), value: 'price_up' },
        { title: this._('По уменьшению цены'), value: 'price_down' },
        { title: this._('По наличию'), value: 'available' },
        { title: this._('От А до Я'), value: 'title_z' },
        { title: this._('От Я до А'), value: 'title_a' },
      ],
      isSelectedArray: true,
      selectedArray: [],
      productResponse: [],
      isSeriesResponse: false,
      seriesResponse: '',
      isLevelsResponse: false,
      levelsResponse: '',
      isCardsResponse: false,
      cardsResponse: [],
      filters: [],
      count: this.pagination.count,
      page: this.pagination.page,
      perPage: this.pagination.perPage,
      isAddPage: false,
      isFirstAdd: true,
      amount: this.productsAmount,
      catalogTitle: null,
      landing: null,
    }
  },
  created() {
    window.onpopstate = async () => {
      window.location.reload()
    }
  },
  async mounted() {
    this.preselectSort()

    await this.checkUrl(this.category)
    await this.prepareFilterData()
    await this.getCardsBlockHeight()
    await this.getFilters()
  },
  methods: {
    preselectSort() {
      const sortFromCookies = getCookie('de_sort_products')
      const valueToFind = sortFromCookies || 'available'

      const option = this.sortArray.find(el => valueToFind === el.value)

      this.sortValue = option
    },

    getFilters() {
      this.isLoad = true
      return catalogFiltersResource.execute({
        category: this.category,
        filters: this.paramsObj,
      })
        .then(res => {
          this.handleFiltersResponse(res)
        })
    },
    handleFiltersResponse(res) {
      this.filters = res.data.items
      this.landing = res.data.landing || null

      if (this.landing && !this.paramsObj[this.landing.filterField]) {
        this.$set(this.paramsObj, this.landing.filterField, [this.landing.filterValue])

        const alreadySelected = this.selectedArray.some(el => el.label === this.landing.filterValue)
        if (!alreadySelected) {
          this.selectedArray.push({
            label: this.landing.filterValue,
            title: this.landing.filterValue,
            name: this.landing.filterField,
            locked: true,
          })
        }
      }

      this.prepareFilterData()
      this.isLoad = false
    },
    // getSeries() {
    //   return catalogSeriesResource.execute({ category: this.category })
    //     .then(res => {
    //       this.handleSeriesResponse(res)
    //     })
    // },
    handleSeriesResponse(res) {
      this.isSeriesResponse = true
      this.seriesResponse = res.data
      // this.getLevels(res.meta.activeSeries)
    },
    // getLevels(series) {
    //   return catalogLevelsResource.execute({
    //     series,
    //     category: this.category,
    //     filters: this.paramsObj,
    //   })
    //     .then(({ data }) => {
    //       this.isLevelsResponse = true
    //       this.levelsResponse = data
    //     })
    // },
    clearFilters() {
      // На посадковій сторінці "Очистити фільтр" → перехід на категорію
      if (this.landing && this.landing.categoryUrl) {
        window.location.href = this.landing.categoryUrl
        return
      }
      this.paramsObj = {}
      this.selectedArray = []
      this.getCardsAndSeries()
      this.isAddPage = false
      this.isFirstAdd = true
    },
    deleteSelectedFilter(data) {
      // На посадковій сторінці видалення базового фільтра → перехід на категорію
      if (this.landing && data.label === this.landing.filterValue) {
        window.location.href = this.landing.categoryUrl
        return
      }
      Object.keys(this.paramsObj).forEach(el => {
        const index = this.paramsObj[el].indexOf(data.label)
        if (-1 !== index) {
          this.paramsObj[el].splice(index, 1)
          if (0 === this.paramsObj[el].length) delete this.paramsObj[el]
        }
        if (data.type && 'range' === data.type) {
          if (el.includes('_min') || el.includes('_max')) delete this.paramsObj[el]
        }
      })
      this.selectedArray = this.selectedArray.filter(el => el.label !== data.label)
      this.getCardsAndSeries()
    },
    async getCardsAndSeries(page = one) {
      await this.formatDataBeforeRequest()
      this.isLoad = true
      Promise.all(
        [
          catalogSeriesResource.execute({
            category: this.category,
            filters: this.paramsObj,
          }),
          catalogCardsResource.execute({
            category: this.category,
            filters: this.paramsObj,
            page,
          }),
          catalogFiltersResource.execute({
            category: this.category,
            filters: this.paramsObj,
          }),
        ]
      ).then(([series, cards, filters]) => {
        this.handleSeriesResponse(series)
        this.handleCardsResponse(cards)
        this.handleFiltersResponse(filters)
      })
    },
    /*
      only after pagination changing,
      because we don't need levels, series and filters
    */
    async getCards(page = one) {
      await this.formatDataBeforeRequest()
      return catalogCardsResource.execute({
        category: this.category,
        filters: this.paramsObj,
        page,
      }).then(res => {
        this.handleCardsResponse(res)
      })
    },
    async formatDataBeforeRequest() {
      if (true === this.isFirstAdd && true === this.isAddPage) {
        await this.getFirstCards(this.page - 1)
      }
      this.paramsObj = this.removeEmpty(JSON.parse(JSON.stringify(this.paramsObj)))
      this.paramsObj.sort = [valueFromSelect(this.sortValue, 'value')]
    },
    async handleCardsResponse(res) {
      await this.handleCombinePagination(res)
      await this.handleCards(res.meta)

      this.catalogTitle = res.title

      // Save sort value to Cookie for set this value to select after page reload
      setCookie('de_sort_products', this.paramsObj.sort[0])

      // Remove sort value from URL to improve SEO
      // It's prevents content duplication
      delete this.paramsObj.sort

      await this.pushHistory()
      this.isLoad = false
    },
    seriesListener(e) {
      const parent = e.target.parentNode
      if (e.target.dataset?.value) {
        if (!parent.classList.contains('is-active')) {
          const seriesCards = document.getElementsByClassName('js-series')
          seriesCards.forEach(el => {
            el.classList.remove('is-active')
          })
          parent.classList.add('is-active')
        }
        // this.getLevels(e.target.dataset.value)
      }
    },
    // get first cards onload, the same as slot contains
    getFirstCards(page = one) {
      return catalogCardsResource.execute({
        category: this.category,
        filters: this.paramsObj,
        page,
      })
        .then(async res => {
          this.firstCards = res.data
        })
    },
    scrollByPagination() {
      if (false === this.isAddPage) {
        const element = this.$refs.cards
        scrollToContent(element)
      }
    },
  },
}
</script>
